import createIcon from '../../createIcon';

/**
 * @component @name RamenDining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA2SDhWNC42NUw5IDQuNTNWNlpNOSAxMkg4VjdIOVYxMlpNNiA3SDdWMTJINlY3Wk02IDQuODhMNyA0Ljc2VjZINlY0Ljg4Wk0yMiAzVjJMNSA0VjEySDJDMiAxNS42OSA0LjQ3IDE4Ljg2IDggMjAuMjVWMjJIMTZWMjAuMjVDMTkuNTMgMTguODYgMjIgMTUuNjkgMjIgMTJIMTBWN0gyMlY2SDEwVjQuNDFMMjIgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RamenDining = createIcon('RamenDining', [
  [
    'path',
    {
      d: 'M9 6H8V4.65L9 4.53V6ZM9 12H8V7H9V12ZM6 7H7V12H6V7ZM6 4.88L7 4.76V6H6V4.88ZM22 3V2L5 4V12H2C2 15.69 4.47 18.86 8 20.25V22H16V20.25C19.53 18.86 22 15.69 22 12H10V7H22V6H10V4.41L22 3Z',
      key: '1w18fy',
    },
  ],
]);

export default RamenDining;
